<template>
    <section class="viewsrhwxControlcomponents_AppointOrderInfo">
        <!-- 订单详情 -->
        <template v-if="mode === 0">
            <div class="top-cont-text">
                <div class="left">关联订单类型：</div>
                <div class="right">{{ params.ref_order_type == 'ncc' ? 'NCC订单' : params.ref_order_type == 'pound' ?
                    '过磅单' : 'TMS订单' }}</div>
            </div>
            <div class="top-cont-text">
                <div class="left">{{ labelCopywriting }}：</div>
                <template v-if="labelCopywriting === '运单号'">
                    <div class="right">{{ params.ref_order && params.ref_order.code || '--' }}</div>
                </template>
                <template v-else>
                    <div class="right">{{ params.ref_order_name || '--' }}</div>
                </template>
            </div>
            <!-- <template v-if="params.ref_order_id && params.ref_order_type == 'ncc' && orderParams['VFIRSTBILLCODE']">
                <div class="top-cont-text">
                    <div class="left">订单号：</div>
                    <div class="right">{{ orderParams['VFIRSTBILLCODE'] || '--' }}</div>
                </div>
            </template>  -->
            <template v-if="params.ref_order_type == 'tms' && rowDataObj.deliver_order">
                <div class="top-cont-text">
                    <div class="left">发货单号：</div>
                    <div class="right">{{ rowDataObj.deliver_order || '--' }}</div>
                </div>
            </template>
        </template>
        <!-- 车辆预约 -->
        <template v-if="mode === 1">
            <div class="cont1">
                <template>
                    <van-cell-group :class="[requried ? 'requried' : '']" style="width: calc(100vh - 34px);">
                        <van-field v-model="params.ref_order_name" :label="labelCopywriting" placeholder="请选择关联订单"
                            readonly @click="onSelectRelationOrder('selector')" style="padding: 16px 0px;"></van-field>
                    </van-cell-group>
                </template>
                <!-- 关联订单选择器 -->
                <AppointOrderSelector :selected="params" ref="selector"
                    :query="{ comId: query.comId, business_id: query.business_id }"
                    @change="handleOrderSelectorChange" />
            </div>
            <!-- <div class="cont1" v-if="params.ref_order_id && params.ref_order_type == 'ncc' && orderParams['VFIRSTBILLCODE']">
                <van-field v-model="orderParams['VFIRSTBILLCODE']" label="订单号" readonly style="padding: 16px 0px;"></van-field>
            </div> -->
            <div class="cont1" v-if="params.ref_order_type == 'tms' && rowDataObj.deliver_order">
                <van-field v-model="rowDataObj.deliver_order" label="发货单号" readonly
                    style="padding: 16px 0px;"></van-field>
            </div>
        </template>
        <!-- 司机车辆预约关联订单 -->
        <template v-if="mode === 2">
            <div class="mt10">
                <template>
                    <van-field v-model="params.ref_order_name" :label="labelCopywriting + '：'" placeholder="请选择关联订单"
                        readonly @click="onSelectRelationOrder('selector')"></van-field>
                </template>
                <!-- 关联订单选择器 -->
                <AppointOrderSelector :selected="params" ref="selector"
                    :query="{ comId: query.comId, business_id: query.business_id }"
                    @change="handleOrderSelectorChange" />
            </div>
            <!-- <div class="mt10" v-if="params.ref_order_id && params.ref_order_type == 'ncc' && orderParams['VFIRSTBILLCODE']">
                <van-field v-model="orderParams['VFIRSTBILLCODE']" label="订单号：" readonly></van-field>
            </div> -->
        </template>
        <template v-if="mode === 3">
            {{ labelCopywriting }}：{{ params.ref_order_name }}<br />
            <!-- <template v-if="params.ref_order_id && params.ref_order_type == 'ncc' && orderParams['VFIRSTBILLCODE']">
                <span class="bk_text">订单号：{{ orderParams['VFIRSTBILLCODE'] }}</span>
            </template> -->
            <template v-if="params.ref_order_type == 'tms' && rowDataObj.deliver_order">
                <span class="bk_text">发货单号：{{ rowDataObj.deliver_order }}</span>
            </template>
        </template>
        <!-- 司机报道关联订单 -->
        <template v-if="mode === 4">
            <!-- <el-input type="text" :autosize="{ minRows: 1 }" resize="none" v-model="params.ref_order_name"
                placeholder="请选择关联订单" readonly @click.native="onSelectRelationOrder('selector')"></el-input> -->
            <el-tag disable-transitions effect="dark" :hit="false" style="margin-right: 10px;margin-bottom: 10px;"
                color="#00c8d2" closable :key="index" v-for="(item, index) in formatRefOrderName"
                @close="handleDriverOrderSelectorClose(item)">{{ item.name
                }}</el-tag>
            <div>
                <el-button class="button-new-tag" size="small" @click="onSelectRelationOrder('selector')">
                    选择关联订单
                </el-button>
            </div>
            <!-- 关联订单选择器 -->
            <AppointOrderSelector :multiple="false" :selected="{
                ref_order_id: '',
                ref_order_type: params.ref_order_type,
                ref_order_name: '',
                ncc_wl_list: params.ncc_wl_list
            }" ref="selector" :query="{ comId: query.comId, business_id: query.business_id, id: query.id }"
                @change="handleDriverOrderSelectorChange" />
        </template>
    </section>
</template>

<script>
import AppointOrderSelector from './AppointOrderSelector'
export default {

    props: {
        readonly: {
            type: Boolean,
            default: false
        },
        query: {
            type: Object,
            default: () => {}
        },
        value: {
            type: String,
            default: ''
        },
        options: {
            type: Object,
            default: () => {}
        },
        requried: {
            type: Boolean,
            default: false
        },
        mode: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            params: {
                ref_order_id: "",
                ref_order_type: "",
                ref_order_name: "",
                ncc_wl_list: []
            },
            orderParams: {}
        };
    },

    computed: {
        labelCopywriting() {
            if (this.params.ref_order_type === "ncc") {
                return "订单号"
            } else if (this.params.ref_order_type === "pound") {
                return "过磅单号"
            } else if (this.params.ref_order_type === "tms") {
                return "运单号"
            } else {
                return "关联订单"
            }
        },
        formatRefOrderName() {
            const ids = this.params.ref_order_id ? this.params.ref_order_id.split("/") : [];
            const names = this.params.ref_order_name ? this.params.ref_order_name.split("/") : [];
            return ids.map((item, index) => {
                return {
                    id: item,
                    name: names[index]
                }
            })
        }
    },

    watch: {
        value() {
            this.init()
        }
    },

    components: {
        AppointOrderSelector
    },

    mixins: [],

    beforeCreate() { },

    created() {
        this.init()
    },

    beforeMount() { },

    mounted() { },

    updated() {
        // this.init()
    },

    activated() { },

    deactivated() { },




    methods: {
        init() {
            if (this.options && this.options.id) {
                this.params = {
                    ref_order_id: this.options.id,
                    ref_order_type: this.options.type,
                    ref_order_name: this.options.name,
                    ncc_wl_list: this.options.ncc_wl_list
                }
                this.rowDataObj = this.options.rowDataObj || {}
                this.$nextTick(() => {
                    if (this.options.type === "ncc") {
                        this.getOrderCode()
                    }
                })
            }
        },
        // 打开关联订单选择器
        onSelectRelationOrder(key) {
            if (this.readonly) {
                return;
            }
            this.$refs[key].open();
        },
        handleDriverOrderSelectorChange(value, type, name, data) {
            let ref_order_id = this.params.ref_order_id ? this.params.ref_order_id.split('/') : [];
            let ref_order_name = this.params.ref_order_name ? this.params.ref_order_name.split('/') : [];
            let ncc_wl_list = this.params.ncc_wl_list || [];
            console.log(data);
            
            if (!ref_order_id.includes(value)) {
                if (type == this.params.ref_order_type) {
                    ref_order_id.push(value);
                    ncc_wl_list = ncc_wl_list.concat(data);
                } else {
                    ref_order_id = [value];
                    ncc_wl_list = data;
                }
            }
            if (!ref_order_name.includes(name)) {
                if (type == this.params.ref_order_type) {
                    ref_order_name.push(name);
                } else {
                    ref_order_name = [name];
                }
            }
            this.handleOrderSelectorChange(ref_order_id.join('/'), type, ref_order_name.join('/'), ncc_wl_list);
        },
        // 获取订单选中回调参数,说明：第一个参数是booking_id，第二个参数是类型，第三个参数是订单信息
        handleOrderSelectorChange(value, type, name, ncc_wl_list) {
            this.params.ref_order_id = value;
            this.params.ref_order_type = type;
            this.params.ref_order_name = name;
            this.params.ncc_wl_list = ncc_wl_list;
            this.$nextTick(() => {
                if (type === "ncc") {
                    // this.getOrderCode();
                } else {
                    this.orderParams = {}
                }
                this.$emit('change', this.params);
            });
        },
        handleDriverOrderSelectorClose(row) {
            let ref_order_id = this.params.ref_order_id ? this.params.ref_order_id.split('/') : [];
            let ref_order_name = this.params.ref_order_name ? this.params.ref_order_name.split('/') : [];
            const value = ref_order_id.filter((e) => e != row.id).join('/');
            const name = ref_order_name.filter((e) => e != row.name).join('/');
            this.handleOrderSelectorChange(value, this.params.ref_order_type, name, this.params.ncc_wl_list);
        },
        // 获取NCC订单号信息
        async getOrderCode() {
            let dataObj = await this.$common.http({
                url: "/api/queue/pound/detail_ncc?id=" + this.params.ref_order_id,
                data: {}
            });
            this.orderParams = dataObj.data.data;

        }
    },

}

</script>
<style lang='less' scoped>
.viewsrhwxControlcomponents_AppointOrderInfo {
    .bk_text {
        word-break: break-all;
    }
    .mt10 {
        margin-top: 10px;
    }
    .cont1 {
        line-height: 54px;
        background: #fff;
        display: flex;
        padding: 0px 15px;
        margin-bottom: 10px;

        .left {
            flex: 1;
        }

        .right {
            flex: 0.5;
            text-align: right;
        }
    }

    .top-cont-text {
        padding: 0px 16px 14px;
        background: #fff;
        display: flex;
        .left {
        // display: inline-block;
        // width: calc(36vw - 0px);
        flex: 1;
        text-align: right;
        margin-right: 40px;
        vertical-align: top;
        color: #b2b2b2;
        }
        .right {
        // display: inline-block;
        // width: calc(44vw - 0px);
        flex: 1.2;
        vertical-align: top;
        word-break: break-all;
        }
    }
    /deep/ .el-tag--dark {
        border-color: #00c8d2;
    }
}
</style>
<style lang='less'>
.viewsrhwxControlcomponents_AppointOrderInfo {}
</style>